<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-12-21 15:01:06
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-03-30 18:21:14
-->
<template>
  <div class="innovative innovative-accuaspects" ref="accuaspects">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/m/innovate/product-list-bj.png')" alt="" srcset="">
      <div class="innovative-bj-title center_up_down_left_right" v-html="$t('product.accuaspects.title')"></div>
    </div>
    <div class="p-t-50 p-b-10">
      <div class="p-l-30 p-r-30">
        <div class="innovative-item-title p-l-25" v-html="$t('product.accuaspects.list[0].title')"></div>
      </div>
      <div class="p-t-28 p-l-10 p-r-15">
        <img class="wid100" :src="$t('product.accuaspects.list[0].img')" alt="" srcset="">
      </div>
      <div class="p-l-30 p-r-30 textj">
        <p class="p-t-20 p-b-20" v-for="item, index in $t('product.accuaspects.list[0].des')" :key="index" v-html="item"></p>
      </div>
    </div>
    <div>
      <div class="accuaspects-characteristics">
        <div class="innovative-container">
          <div class="innovative-item-title" v-html="$t('product.accuaspects.list[1].title')"></div>
          <div class="accuaspects-characteristics-box">
            <div class="p-t-20 p-b-20" v-for="item, index in $t('product.accuaspects.list[1].des')" :key="index">
              <div class="flex justify_content_center p-b-15">
                <img class="accuaspects-characteristics-img" :src="item.img" alt="" srcset="">
              </div>
              <div class="innovative-wrap-item-title fz-30 p-b-25 textc" v-html="item.title"></div>
              <p class="innovative-characteristics-item" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="accuaspects-advantages innovative-container">
      <div class="innovative-item-title widauto" :class="language == 'en' ? 'heiauto' : ''" v-html="$t('product.accuaspects.list[2].title')"></div>
      <img class="wid100" :src="$t('product.accuaspects.list[2].img')" alt="" srcset="">
    </div>
    <div class="innovative-container">
      <div class="p-t-20 article">
        <div class="innovative-item-title" v-html="$t('product.accuaspects.article.title')"></div>
        <div class="p-t-15">
          <p class="p-t-15" v-for="item, index in $t('product.accuaspects.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['language'])
  }
}
</script>

<style lang="less">
@import "~@/styles/m/products.less";
</style>

<style lang="less" scoped>
.m .innovative-accuaspects {
  .accuaspects-characteristics {
    background-image: url('~@/assets/images/innovate/AccuASPECTS/m_2.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: top;
    padding: 20px 0;
    .accuaspects-characteristics-box {
      background: #FFFFFF;
      box-shadow: 0px 4px 12px 4px rgba(81,170,255,0.1);
      padding: 50px 50px 50px 40px;
    }
    .accuaspects-characteristics-img {
      max-height: 62px;
    }
  }
  .accuaspects-advantages {
    background: #F8FBFF;
    border-radius: 8px;
    padding-bottom: 50px;
  }
}
</style>
